import type { AdSenseConfig } from './config';

type AdSenseWindow = Window & { adsbygoogle?: { push: (request: Record<string, never>) => unknown } };

let loading: Promise<void> | undefined;

/** One provider script per document. No automatic retry or timed ad refresh. */
function loadAdSense(clientId: string): Promise<void> {
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
    const timeout = window.setTimeout(() => finish(new Error('AdSense không phản hồi.')), 15000);
    function finish(error?: Error) {
      window.clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      error ? reject(error) : resolve();
    }
    script.onload = () => finish();
    script.onerror = () => finish(new Error('Không tải được AdSense.'));
    document.head.append(script);
  });
  return loading;
}

export async function requestAdSense(
  element: HTMLElement,
  config: AdSenseConfig,
  cancelled: () => boolean,
): Promise<void> {
  if (cancelled() || !element.isConnected || element.offsetWidth === 0) return;
  await loadAdSense(config.clientId);
  // A resize or unmount can happen while the provider script loads.
  if (cancelled() || !element.isConnected || element.offsetWidth === 0 ||
    element.dataset.adRequested || element.dataset.adsbygoogleStatus) return;
  element.dataset.adRequested = 'true';
  const adWindow = window as AdSenseWindow;
  const queue = adWindow.adsbygoogle ?? (adWindow.adsbygoogle = [] as Record<string, never>[]);
  queue.push({});
}
